import request from '@/interceptor/request'
export default request
